export const filterAttributeCodeValueType = {
    filterEqualType: [
        'age',
        'brand',
        'category_id',
        'chat_lieu_go',
        'color',
        'denomination',
        'dungtich',
        'gram',
        'sex',
        'size',
        'size_bim',
        'sku',
        'so_tang',
        'made_in',
        'nipple_size',
        'weight_bim',
    ],
    getFilterEqualTypeValue: (values: any[]) => {
        return {in: values};
    },
    filterMatchType: ['best_seller_sorting', 'kich_thuoc', 'name', 'ratings_summary', 'url_key'],
    getFilterMatchTypeValue: (values: string) => {
        return {match: values};
    },
    filterRangeType: ['price', 'promotion_info_time_from', 'promotion_info_time_to'],
    getFilterRangeTypeValue: (values: any[]) => {
        return {from: values[0], to: values[1]};
    },
};

export const quantitativeAttributes = ['age', 'denomination', 'dungtich', 'gram', 'kichthuoc', 'size', 'size_bim'];

export const disabledAttributes = [
    'attribute_set_id',
    'kich_thuoc',
    'ratings_summary',
    'category_id',
    'news_from_date',
    'news_to_date',
    'has_gift',
    'relevance',
    'new_product',
    'ratings_count',
    'hot_product',
];

export const ORDER_DOCS = '__other_docs';
